import React from "react";
import "rc-time-picker/assets/index.css";
import moment from "moment";
import TimePicker from "rc-time-picker";
import * as constants from "../const";
import Select from "react-simple-select";
import { Tr, Td } from "react-super-responsive-table";
import "react-super-responsive-table/src/SuperResponsiveTableStyle.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class Activity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      enableType: false,
        date: moment(new Date(), "MM/DD/YYYY")      
    }
    this.errMessage = '';
    this.handleValueChange = this.handleValueChange.bind(this);
      this.enableEndDateTime = false;
      this.enableEndLoc = false;
  }

    ChangingActivity(container, field, activityKey, time) {
     
    this.props.onChangeActivity(container, field, activityKey, time);
  }

  isDeadHeadAvailable(type){
    let isAvailable = this.props.workday.duty_activity.filter(d => d.dty_act_name == type && d.dty_act_name.includes("Deadhead") && !d.isDeleted);
    return isAvailable.length > 0 ? true : false;
  }
 
  // activity selection changed
  changeActivity(val) {
    let self = this;
    if (val != null) 
      //Note : In UAT this validation needs to add on client's confirmation
      // && !this.props.isLogUser) ||
      //     (val != null && this.props.isLogUser && !this.isActivityAvail(val.target.value))) 
    {
      this.refs.act_name = val.target.value;
      this.ChangingActivity(this, "name", this.props.duty_activity_key);
      if(this.props.isLogUser){
        let deadheadActivities =  this.props.workday.duty_activity.filter((d) => {
          let act_name = d.dty_act_name_updated?d.dty_act_name_updated : d.dty_act_name
          return act_name.trim().includes("Deadhead") && !d.isDeleted;
        });
        if(deadheadActivities.length == 1){
          let toBeAddType = "";
          let deadhead_str = '';
          switch(val.target.value){
            case "Deadhead from":
              toBeAddType = "Deadhead to";
              deadhead_str = "Deadhead Start";
              break;
            case "Deadhead to":
              toBeAddType = "Deadhead from";
              deadhead_str = "Deadhead End"
              break;
            default:
              toBeAddType = ""
          }
          if(toBeAddType.length > 0){
            //this.props.onAddDeadhead(toBeAddType);
            this.props.setDeadheadWarning(true,`${deadhead_str} is missing.`)
          }
          else{
            this.props.setDeadheadWarning(false,"");
          }
        }
        else{
          this.props.setDeadheadWarning(false,"");
        }
      }
      if(this.props.isLogUser && val.target.value && !val.target.value.toLowerCase().includes("deadhead")){
        this.props.Activity.dty_act_type = '';
      }

      let activity = this.props.Activity;
      let startTime = typeof this.refs.startTime == 'string' ? this.refs.startTime : this.refs.startTime.picker.value;
      let endTime = typeof this.refs.endTime == 'string' ? this.refs.endTime : this.refs.endTime.picker.value;
      this.handleValueChange(startTime, this, 'start', activity.duty_activity_key);
      this.handleValueChange(endTime, this, 'end', activity.duty_activity_key);
      self.errMessage = constants.errMessages.invalidActivity;
      
      //recalculate thos
      if(this.props.isLogUser && (val.target.value.includes("Deadhead") || val.target.value.toLocaleLowerCase().includes('split break'))){
        if(!this.props.activityErr){
          this.props.renderWorkdayDetails();
        }
      }
    }
  }

  setRawValue(activity, time, property) {
    var hoursAndMinutes = time.split(" ")[0];
    var hours = parseInt(hoursAndMinutes.split(":")[0], 10);
    var minutes = parseInt(hoursAndMinutes.split(":")[1], 10);
    var h = hours,
      m = minutes;
    var timeString = time.split(" ")[1].toUpperCase();
    if (timeString === "PM") {
      if (hours === 12) {
        h = 12;
      } else if (hours < 12) {
        h = hours + 12;
      }
    } else {
      if (hours === 12) {
        h = 0;
      } else if (hours === 0) {
        h = 0;
      }
    }
    hours = h;

    if (this.props.rawValue === 24) {
      if (hours > 12) {
        h = hours;
      } else if (hours === 12) {
        h = 12;
      } else if (hours === 0) {
        h = 24;
      } else if (hours < 12) {
        h = h + 24;
      }
    }
    if (m < 10) {
      m = "0" + m;
    }

    time = h + ":" + m;
    return { property: property, rawTime: time };
  }

  // on changing start time
  onStartTimeConfirm(value, property, duty_activity_key) {
    if (!this.props.Activity.isMisc) {
      var self = this;
      setTimeout(function () {
        self.refs.act_name = self.props.Activity.dty_act_name_updated
          ? self.props.Activity.dty_act_name_updated
          : self.props.Activity.dty_act_name;
        var activity = self.props.Activity;
        var rawTime = self.setRawValue( // setting raw time
          activity,
          value.refs.startTime.picker.value,
          "dty_act_start_time_raw"
        );
        var act_name = value.refs.act_name;
        self.ChangingActivity(value, property, duty_activity_key, rawTime);
        var time = self.props.Activity.dty_act_start_time_updated
          ? self.props.Activity.dty_act_start_time_updated
          : self.props.Activity.dty_act_start_time;
        activity = self.props.Activity;

        // checking start time is valid or not
        var isInValid = self.props.validateTime(time, activity, false);

        if (isInValid !== true && act_name != '') {
          self.props.setActivityErr(duty_activity_key, false);
          self.props.onActErr(false, false); // para1: errpop, para2: acterr
        } else {
          if (!self.refs.act_name) {
            self.errMessage = 'Please select activity for newly added activity';
          } else {
            self.errMessage = self.props.getError();
          }
          self.props.setActivityErr(duty_activity_key, true);
          self.props.onActErr(true, true, self.errMessage); // para1: errpop, para2: acterr
        }
      }, 500);
    } else {
      this.props.setActivityErr(duty_activity_key, false);
      this.props.onActErr(false, false);
    }
  }

  // on changing end time
  onEndTimeConfirm(value, property, duty_activity_key) {
    if (!this.props.Activity.isMisc) {
      var self = this;
      setTimeout(function () {
        self.refs.act_name = self.props.Activity.dty_act_name_updated
          ? self.props.Activity.dty_act_name_updated
          : self.props.Activity.dty_act_name;
        var activity = self.props.Activity;
        var rawTime = self.setRawValue( // setting raw time
          activity,
          value.refs.endTime.picker.value,
          "dty_act_end_time_raw"
        );
        self.ChangingActivity(value, property, duty_activity_key, rawTime);
        var time = self.props.Activity.dty_act_end_time_updated
          ? self.props.Activity.dty_act_end_time_updated
          : self.props.Activity.dty_act_end_time;
        activity = self.props.Activity;
        var act_name = value.refs.act_name;

        // checking start time is valid or not
        var isInValid = self.props.validateTime(time, activity, true);

        if (isInValid !== true && act_name != '') {
          self.props.setActivityErr(duty_activity_key, false);
          self.props.onActErr(false, false);
        } else {
          if (!self.refs.act_name) {
            self.errMessage = 'Please select activity for newly added activity';
          } else {
            self.errMessage = self.props.getError();
          }
          self.props.setActivityErr(duty_activity_key, true);
          self.props.onActErr(true, true, self.errMessage);
        }
      }, 500);
    } else {
      this.props.setActivityErr(duty_activity_key, false);
      this.props.onActErr(false, false);
    }
  }
  onMiscTimeConfirm(value, property, duty_activity_key) {
    setTimeout(() => {
      this.refs.act_name = this.props.Activity.dty_act_name_updated
        ? this.props.Activity.dty_act_name_updated
        : this.props.Activity.dty_act_name;
      let time = moment(value).format('HH:mm');
      this.ChangingActivity(this, property, duty_activity_key, time);
    }, 100);
  }

  handleDateChange(date, store, property, duty_activity_key){
    var self = store;
      if (date != null) {
          if (property === "end") {
              this.enableEndDateTime = true;
              this.props.onEndDateChange();
          }
      let selectedDate = moment(date,"MM/DD/YYYY").format("MM/DD/YYYY");
      self.refs[`${property}_date`] = selectedDate;
      self.refs.act_name = self.props.Activity.dty_act_name_updated
        ? self.props.Activity.dty_act_name_updated
        : self.props.Activity.dty_act_name;
      store.ChangingActivity(store, property, duty_activity_key);
      var activity = self.props.Activity;
      let isInValid = self.props.validateHoslogTime(activity, property);
      if (isInValid !== true && self.refs.act_name != '') {
        self.props.setActivityErr(duty_activity_key, false);
        self.props.onActErr(false, false); // para1: errpop, para2: acterr
      } else {
        if (!self.refs.act_name) {
          self.errMessage = 'Please select activity for newly added activity';
        } else {
          self.errMessage = self.props.getError();
        }
        self.props.setActivityErr(duty_activity_key, true);
        self.props.onActErr(true, true, self.errMessage); // para1: errpop, para2: acterr
      }
    }
  }
  handleHosLogChange(e, store, property, duty_activity_key) {
    var self = store;
      if (e != null) {
          if (property === "end") {
          this.enableEndLoc = true;
            
          }
          
      self.refs[`${property}_place`] = e.target.value;
      self.refs.act_name = self.props.Activity.dty_act_name_updated
        ? self.props.Activity.dty_act_name_updated
        : self.props.Activity.dty_act_name;
        
      store.ChangingActivity(store, property, duty_activity_key);
    }
  }
  handleDeadheadChange(val) {
    let self = this;
    if (val != null) {
      self.refs.deadhead_type = val.target.value;
      self.refs.act_name = self.props.Activity.dty_act_name_updated
        ? self.props.Activity.dty_act_name_updated
        : self.props.Activity.dty_act_name;
      this.ChangingActivity(this, "deadhead_type", this.props.duty_activity_key);
    }
  }

  handleValueChange(value, store, property, duty_activity_key) {
    if (!store.props.Activity.isMisc) {
      var self = store;
      setTimeout(function () {
        let updatedTime = '';
        if (typeof value == "string") {
          updatedTime = value;
        } else {
          updatedTime = value.picker && value.picker.value || value.format('h:mm A');
        }

        store.refs[`${property}Time`] = updatedTime;

        self.refs.act_name = self.props.Activity.dty_act_name_updated
          ? self.props.Activity.dty_act_name_updated
          : self.props.Activity.dty_act_name;
        var activity = self.props.Activity;
        var rawTime = self.setRawValue( // setting raw time
          activity,
          updatedTime,
          property == 'start' ? "dty_act_start_time_raw" : "dty_act_end_time_raw"
        );
        var act_name = self.refs.act_name;
        self.ChangingActivity(store, property, duty_activity_key, rawTime);
        let propToChk = `dty_act_${property}_time_updated`;
        var time = self.props.Activity[propToChk]
          ? self.props.Activity[propToChk]
          : self.props.Activity[`dty_act_${property}_time`]
        activity = self.props.Activity;

        // checking start time is valid or not
        var isInValid;
        if(self.props.isLogUser){
          //tochange
          isInValid = self.props.validateHoslogTime(activity, property);
        }
        else{
          isInValid = self.props.validateTime(time, activity, property == 'start' ? false : true);
        }

        if (isInValid !== true && act_name != '') {
          self.props.setActivityErr(duty_activity_key, false);
          self.props.onActErr(false, false); // para1: errpop, para2: acterr
        } else {
          if (!self.refs.act_name) {
            self.errMessage = 'Please select activity for newly added activity';
          } else {
            self.errMessage = self.props.getError();
          }
          self.props.setActivityErr(duty_activity_key, true);
          self.props.onActErr(true, true, self.errMessage); // para1: errpop, para2: acterr
        }
      }, 500);
    } else {
      this.props.setActivityErr(duty_activity_key, false);
      this.props.onActErr(false, false);
    }
  }
  // render activity row in edit mode

  renderEditMode(props, key) {
    let self = this;
    
    setTimeout(function () { // disabling activities dropdown 0th value      
      document.getElementsByClassName("locations")[0].options[0].disabled = true;      
    }, 5);

    const format = "h:mm a", activity = this.props.Activity.dty_act_name_updated && this.props.Activity.dty_act_name_updated != null &&
      typeof this.props.Activity.dty_act_name_updated == "string" ? (
        this.props.Activity.dty_act_name_updated
      ) : this.props.Activity.dty_act_name;
      var endTime = '';
     


    if (this.props.Activity.dty_act_end_time_updated) {
      if (typeof this.props.Activity.dty_act_end_time_updated != 'string') {
        endTime = this.props.Activity.dty_act_end_time_updated.picker.value;
      } else {
        endTime = this.props.Activity.dty_act_end_time_updated;
      }
    } else {
      endTime = this.props.Activity.dty_act_end_time;
    }

    var startTime = '';
    if (this.props.Activity.dty_act_start_time_updated) {
      if (typeof this.props.Activity.dty_act_start_time_updated != 'string') {
        startTime = this.props.Activity.dty_act_start_time_updated.picker.value;
      } else {
        startTime = this.props.Activity.dty_act_start_time_updated;
      }
    } else {
      startTime = this.props.Activity.dty_act_start_time;
    }

    //miscTime = this.props.Activity.dty_act_misc_time ? this.props.Activity.dty_act_misc_time : this.props.Activity.dty_act_misc_time_updated;
    var miscTime = this.props.Activity.dty_adjusted_value;
    startTime = moment(startTime, "h:mm A");
    endTime = moment(endTime, "h:mm A");
    var splittedMiscTime = moment(miscTime, "hh:mm");
    var defaultTime = moment("00:00 AM", "h:mm A");
    var time = this.props.Activity.dty_act_start_time_updated;
    if (startTime.format("h:mm A") == "Invalid date") {
      startTime = moment("00:00 AM", "h:mm A"); // default time
    }
    if (endTime.format("h:mm A") == "Invalid date") {
      endTime = moment("00:00 AM", "h:mm A"); // default time
    }

    var activityNamesArr = this.props.dbActivities; // get all the activities
    function activityNamesFilter(item) {
      // what to show in Activity Dropdown
      return {
        key: item.id,
        value: item.name,
        label: item.name
      };
    };
    function isDeadHeadType(value) {
      let result = value.toString().toLowerCase().includes('deadhead') 
      return result
    }
    function activityNamesFilterHos(item) {
      // what to show in Activity Dropdown
      return {
        key: item.id,
        value: item.name,
        label: item.activity_name
      };
    };
    var toolTip = this.props.Activity.dty_trp_id && this.props.Activity.dty_trp_id != "NULL" ?
      this.props.Activity.dty_trp_id : this.props.Activity.dty_act_name,
      workdayToggled = this.props.workdayToggled ? this.props.workdayToggled : false;

    // toggling activitiwes based on activity name and toggle state
    var eventKey = this.props.eventKey;
    var disableStartEndTime = this.props.Activity.isMisc ? true : false;
    var disableMiscTime = this.props.Activity.isMisc ? this.props.Activity.disableMisc || (activity == 'Diversion' || activity == 'Locomotive Engineer Stipend') ? true : false : true;
    const tableRowState = (eventKey == 1) && (activity != 'Sign-on' && activity != 'Split break' && activity != 'Sign-off') ? 'hidden' : 'block';
    const tableRowClass = `${tableRowState}`;
    let startDate = this.props.Activity.dty_act_start_date ? this.props.Activity.dty_act_start_date : this.props.workday.wdy_date
    let endDate = this.props.Activity.dty_act_end_date ? this.props.Activity.dty_act_end_date : this.props.workday.wdy_date
      var isImpHosLog = this.props.impersonateUserId > 0 && this.props.isLogUser; 
      //check for loading of activity first time and before save
      let doNotshowEndtimeOrLoc = this.props.workday && this.props.workday.IsAmendment == '0' && (this.props.workday.wdy_certify_status.trim().toUpperCase() == 'U')
          && (props.workday.AllowAmendmentEdit == undefined) && !(this.props.role == constants.roles.ADMIN_ROLE); 
          this.props.Activity.dty_act_end_place = (this.enableEndLoc || !doNotshowEndtimeOrLoc) ?this.props.Activity.dty_act_end_place:"";
          this.props.Activity.dty_act_end_date = (this.enableEndDateTime || !doNotshowEndtimeOrLoc  ) ? this.props.Activity.dty_act_end_date:'';
    return (
      <Tr key={key} classes={this.props.isLogUser ? '' : tableRowClass}>
        <Td className={this.props.isLogUser ? "hoslogtablecolactivity" : "activityName"} >
          <Select unselected={{
            value: "",
            label: "--Select Activity--"
          }}
            items={activityNamesArr} itemFilter={this.props.isLogUser ? activityNamesFilterHos : activityNamesFilter}
            value={activity.trim()} className={"locations " + "locations" + key}
            onChange={this.changeActivity.bind(this)} ref="act_name" />
        </Td>
        <Td className={this.props.isLogUser ? "logTime" : "hidden"}>
          <input type="text" style={{ width: '100%' }} value={this.props.Activity.dty_act_start_place}
            onChange={(e) => this.handleHosLogChange(e, this, "start", this.props.duty_activity_key)} ref="start_place" />
        </Td>
        <Td className={this.props.isLogUser ? "logTime" : "hidden"}>
                <input type="text" style={{ width: '100%' }} value={
                    
                    (this.enableEndLoc || !doNotshowEndtimeOrLoc) ? this.props.Activity.dty_act_end_place:""
                }
            onChange={(e) => this.handleHosLogChange(e, this, "end", this.props.duty_activity_key)} ref="end_place" />
        </Td>
        <Td className={this.props.isLogUser ? "logTime" : "hidden"}>
          
          <select
           disabled={!isDeadHeadType(activity)}
           value={isDeadHeadType(activity) ? this.props.Activity.dty_act_type : ''}
           onChange={this.handleDeadheadChange.bind(this)} 
           ref="deadhead_type">
            <option value="">--Select Type--</option>
            {constants.logTypes.DEADHEAD_TYPE.map(function(type, key){
              return <option key={key} value={type.id}>{type.name}</option>;
            })}
          </select>
        </Td>
        <Td className={this.props.isLogUser ? "logTime" : "activityTime"}>
                <DatePicker className={this.props.isLogUser || isImpHosLog ? "" : "hidden"} selected={moment(startDate,"MM/DD/YYYY")} 
                onChange={(e) => this.handleDateChange(e, this, "start", this.props.duty_activity_key)} ref="start_date" />
          <TimePicker ref="startTime"
            onChange={(e) => this.handleValueChange(e, this, "start", this.props.duty_activity_key)}
            disabled={disableStartEndTime}
            value={startTime} className="xxx" use12Hours showSecond={false} />
        </Td>
            <Td className={this.props.isLogUser ? "logTime" : "activityTime"}> 
                <DatePicker className={this.props.isLogUser || isImpHosLog ? "" : "hidden"} selected={(this.enableEndDateTime || !doNotshowEndtimeOrLoc  ) ? moment(endDate, "MM/DD/YYYY"):null} 
                onChange={(e) => this.handleDateChange(e, this, "end", this.props.duty_activity_key)} ref="end_date"  />
          <TimePicker
            ref="endTime"
            onChange={(e) =>
              this.handleValueChange(e, this, "end", this.props.duty_activity_key
              )}
                    disabled={disableStartEndTime} value={endTime} className="xxx" use12Hours showSecond={false} />
        </Td>
        <Td className={this.props.isLogUser ? "hidden" : "miscTime"}>
          <TimePicker ref="miscTime"
            disabled={disableMiscTime}
            onChange={(e) => this.onMiscTimeConfirm(e, 'misc_time', this.props.duty_activity_key)}
            value={splittedMiscTime} showSecond={false} />
        </Td>
        <Td className={!this.props.showAction ? "hidden" : "activityActions"}>
          {this.props.showAction ? (
            <button disabled={this.props.postInProgress}
              onClick={() =>
                this.props.onDeleteActivity(this.props.duty_activity_key)}>
              <i className="fa fa-minus-circle deleteIcon" name="minus-circle" />
            </button>
          ) : ("")}
        </Td>
      </Tr>
    );
  }

  checkEnteredTime(beginningTime, endTime) {
    if (beginningTime.isBefore(endTime) || beginningTime.isAfter(endTime)) {
      return true;
    }
    return false;
  }

  // render view mode of activities
  renderViewMode(props, key) {
    var activity = this.props.Activity,
      certifyStatus = this.props.workday.wdy_certify_status,
      claimStatus = this.props.workday.wdy_claim_status,
      adjustedHOS = this.props.adjustedHOS;
      //check for loading of activity first time and before save
      let doNotshowEndtimeOrLoc = this.props.workday && this.props.workday.IsAmendment == '0' && (this.props.workday.wdy_certify_status.trim().toUpperCase() == 'U')
          && (props.workday.AllowAmendmentEdit == undefined); //&& !(this.props.role == constants.roles.ADMIN_ROLE);

   
    if (claimStatus == constants.ACCEPTED_CLAIM) {
      adjustedHOS = true;
    }
    if(this.props.isLogUser){
      adjustedHOS = false;
    }
    var toolTip = this.props.Activity.dty_trp_id && this.props.Activity.dty_trp_id != "NULL" ? this.props.Activity.dty_trp_id : this.props.Activity.dty_act_name;
    var role = this.props.role;

    // checking activity name updated or not
    var getActName = function () {
      if (constants.roles.ADMIN_ROLE == role && adjustedHOS) {
        return activity.dty_act_name_updated && activity.dty_act_name_updated != 'null'
          ? activity.dty_act_name_updated
          : activity.dty_act_name;
      } else if (activity.dty_act_isNew) {
        return activity.dty_act_name;
      } else if (activity.dty_act_name_updated && activity.dty_act_name_updated != 'null') {
        if (activity.dty_act_name != activity.dty_act_name_updated && activity.dty_act_name_updated != 'null') {
          return activity.dty_act_name_updated;
        } else {
          return activity.dty_act_name;
        }
      } else {
        return activity.dty_act_name;
      }
    };

    var act_name = getActName();
    // checking start time updated or not
    var beginningTime = moment(activity.dty_act_start_time, "h:mm a"),
      endTime = moment(activity.dty_act_start_time_updated, "h:mm a"),
      startTimeUpdated = this.checkEnteredTime(beginningTime, endTime);

    // checking end time updated or not
    var beginningTime = moment(activity.dty_act_end_time, "h:mm a"),
      endTime = moment(activity.dty_act_end_time_updated, "h:mm a"),
      endTimeUpdated = this.checkEnteredTime(beginningTime, endTime);
    let deadheadtype = activity.dty_act_type ? constants.logTypes.DEADHEAD_TYPE.find(x => x.id == activity.dty_act_type.toString()): "" ;

    var displayActivityName = function (isLogUser = false) {
      if(isLogUser == true) {
        return deadheadtype ? 
              <span>{activity.acivity_alias_name} <br /> {'(' + deadheadtype.name + ')'}</span> : <span>{activity.acivity_alias_name}</span>
      }
      
      if (role == constants.roles.ADMIN_ROLE) {
        if (adjustedHOS) {
          return <span className={activity.dty_act_isNew || activity.dty_act_name_updated && activity.dty_act_name_updated != 'null' && (activity.dty_act_name_updated != activity.dty_act_name) ? ("claim-color") : ("")}>
            {act_name}
          </span>
        } else if (activity.dty_act_isNew) {
          if (claimStatus == constants.PENDING_CLAIM) {
            return false;
          } else if (claimStatus == constants.REJECTED_CLAIM || claimStatus == constants.CERTIFIED || certifyStatus == constants.CERTIFIED) {
            return <span>{act_name}</span>
          } else {
            return <span>{activity.dty_act_name}</span>
          }
        } else {
          return <span>{activity.dty_act_name}</span>
        }
      } else {
        if (certifyStatus == constants.CLAIM) {
          return <span className={activity.dty_act_isNew || (activity.dty_act_name_updated != activity.dty_act_name &&
            activity.dty_act_name_updated && activity.dty_act_name_updated != 'null') ? ("claim-color") : ("")}>
            {act_name}
          </span>
        } 
        else {
          return <span>{activity.dty_act_name}</span>
        }
      }
    }
    var isEdit = this.props.Activity.isEditClick === true || this.props.Activity.isNew;
    var actName = displayActivityName(this.props.isLogUser);
    var workdayToggled = this.props.workdayToggled ? this.props.workdayToggled : false;
    var eventKey = this.props.eventKey ? this.props.eventKey : 1;
    const tableRowState = (constants.roles.ADMIN_ROLE == role && !adjustedHOS && activity.dty_act_isNew && claimStatus == constants.PENDING_CLAIM) ? ' hidden' :
      (constants.roles.ADMIN_ROLE != role && (eventKey == 1) && (act_name != "Sign-on" && act_name != "Split break" && act_name != "Sign-off")) ? 'hidden' : (eventKey == 2) ? 'block' : '';
    const isDeletedActivity = adjustedHOS && activity.isDeleted ? 'isDeletedActivity' : '';
    const classes = `${tableRowState} ${isDeletedActivity}`;
    var miscTime = activity.dty_adjusted_value_updated ? activity.dty_adjusted_value_updated : activity.dty_adjusted_value;
    miscTime = miscTime.split(':')[0] + 'h' + miscTime.split(':')[1];
    var miscActivityTime = activity.dty_adjusted_value.split(':')[0] + 'h' + activity.dty_adjusted_value.split(':')[1];
    var isImpHosLog = this.props.impersonateUserId > 0 && this.props.isLogUser; 
   
    return (
      <Tr key={key} className={this.props.isLogUser ? '' : classes}>
        <Td className={this.props.isLogUser ? "hoslogtablecolactivity" : "activityName"}>{actName}</Td>
        <Td className={this.props.isLogUser ? "logTime" : "hidden"}>
          <span>{activity.dty_act_start_place}</span>
        </Td>
        <Td className={this.props.isLogUser ? "logTime" : "hidden"}>
                <span>{
                    (doNotshowEndtimeOrLoc) ? "" : activity.dty_act_end_place
                }</span>
        </Td>
        <Td className={this.props.isLogUser ? "logTime hidden" : "hidden"}>{deadheadtype ? deadheadtype.name : ''}</Td>
        <Td className={this.props.isLogUser ? "logTime" : "activityTime"}>
          {isImpHosLog ? activity.dty_act_start_date_time : this.props.impersonateUserId > 0 ? (activity.dty_act_start_time_updated || activity.dty_act_start_time) : this.props.isLogUser ? activity.dty_act_start_date_time : role == constants.roles.ADMIN_ROLE ? adjustedHOS ? (
            <span className={
              activity.dty_act_isNew || startTimeUpdated ? "claim-color" : ""
            }>{
                startTimeUpdated ? (activity.dty_act_start_time_updated) :
                  (activity.dty_act_start_time)
              }
            </span>
          ) : activity.dty_act_isNew ? claimStatus == constants.PENDING_CLAIM ? false : claimStatus == constants.REJECTED_CLAIM || certifyStatus == constants.CERTIFIED || claimStatus == constants.CERTIFIED ? activity.dty_act_start_time_updated ? activity.dty_act_start_time_updated : activity.dty_act_start_time :
            activity.dty_act_start_time : (
                activity.dty_act_start_time
              ) : certifyStatus == constants.CLAIM || claimStatus == constants.ACCEPTED_CLAIM ? (
                <span className={
                  activity.dty_act_isNew || startTimeUpdated ? !this.props.isLogUser ? "claim-color" : "" : ""
                }>
                  {startTimeUpdated ? (activity.dty_act_start_time_updated) :
                    (activity.dty_act_start_time)}
                </span>) : (activity.dty_act_start_time)}
        </Td>
            <Td className={this.props.isLogUser ? "logTime" : "activityTime " + this.props.impersonateUserId}>
                {
                    (doNotshowEndtimeOrLoc) ? "" :
                        
                            isImpHosLog ? activity.dty_act_end_date_time : this.props.impersonateUserId > 0 ? (activity.dty_act_end_time_updated || activity.dty_act_end_time) : this.props.isLogUser ? activity.dty_act_end_date_time : role == constants.roles.ADMIN_ROLE ?
                    adjustedHOS ? (
                      <span className={activity.dty_act_isNew || endTimeUpdated ? "claim-color" : ""}>
                                    {
                                                           
                                        endTimeUpdated ? (activity.dty_act_end_time_updated) : (activity.dty_act_end_time)
                            
                                    }
                      </span>
                    ) : activity.dty_act_isNew ? claimStatus == constants.PENDING_CLAIM ? false : claimStatus == constants.REJECTED_CLAIM || claimStatus == constants.CERTIFIED || certifyStatus == constants.CERTIFIED ? (activity.dty_act_end_time_updated ? activity.dty_act_end_time_updated : activity.dty_act_end_time) : activity.dty_act_end_time : (activity.dty_act_end_time) : certifyStatus == constants.CLAIM || claimStatus == constants.ACCEPTED_CLAIM ? (
                      <span className={activity.dty_act_isNew || endTimeUpdated ? !this.props.isLogUser ? "claim-color" : "": ""}>
                                    {
                                            
                                        endTimeUpdated ? (activity.dty_act_end_time_updated) : (activity.dty_act_end_time)
                                    }
                                </span>) : (activity.dty_act_end_time )
                
                }
        </Td>
        <Td className={(eventKey == 1 && !(role == constants.roles.ADMIN_ROLE)) || this.props.isLogUser ? "hidden" : "miscTime"}>
          {role == constants.roles.ADMIN_ROLE ?
            adjustedHOS ? (
              <span className={activity.dty_act_isNew || activity.dty_adjusted_value_updated ? (activity.dty_adjusted_value_updated != activity.dty_adjusted_value) ? "claim-color" : "" : ""}>
                {miscTime}
              </span>
            ) : activity.dty_act_isNew ? claimStatus == constants.PENDING_CLAIM ? false : claimStatus == constants.REJECTED_CLAIM || claimStatus == constants.CERTIFIED || certifyStatus == constants.CERTIFIED ? miscTime : miscActivityTime : miscActivityTime : certifyStatus == constants.CLAIM || claimStatus == constants.ACCEPTED_CLAIM ? (
              <span className={activity.dty_act_isNew || activity.dty_adjusted_value_updated ? (activity.dty_adjusted_value_updated != activity.dty_adjusted_value) ? "claim-color" : "" : ""}>
                {miscTime}
              </span>) : miscActivityTime}
        </Td>
        <Td className={"activityActions " + ((role == constants.roles.ADMIN_ROLE || this.props.isHOSModal || (this.props.isLogUser && !isEdit)) ? 'hidden' : 'block')}>
          {this.props.showAction ? (
            <button className={"activityActions " + (!this.props.showAction || !this.props.activitiesEditMode ? "hidden" : "")}
              disabled={this.props.activityErr || this.props.postInProgress ? "disabled" : ""}
              onClick={() =>
                this.props.onDeleteActivity(this.props.duty_activity_key)}>
              <i className="fa fa-minus-circle deleteIcon" name="minus-circle" />
            </button>
          ) : ("")}
        </Td>
      </Tr>
    );
  }
  render() {

    if (this.props.Activity.isEditClick === true || this.props.Activity.isNew) {
 
      return this.renderEditMode(this.props, this.props.id);
    } else {
 
      return this.renderViewMode(this.props, this.props.id);
    }
  }
}

export default Activity;